import React from 'react';
import ProductCard from './ProductCard';
import { products as mockProducts } from '../data/mock';

const MachinesSection = ({ products }) => {
  const displayProducts = products && products.length > 0 ? products : mockProducts;

  return (
    <section id="machines" className="py-24 bg-stone-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-stone-800 mb-4">
            Nuestras Máquinas
          </h2>
          <div className="h-1 w-24 bg-clay-primary mx-auto mb-6"></div>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto">
            Maquinaria industrial de alta precisión, diseñada y fabricada para optimizar tu producción cerámica
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {displayProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MachinesSection;
